export default {
    methods: {
        scrollToRef(ref) {
            if (!this.$refs[ref]) return false;

            console.log(this.$refs[ref].$el);
            this.$refs[ref].$el.scrollIntoView({
                behavior: "smooth"
            });
        }
    }
};
